import gameIcon from '../../build/icon.png?url';
import heroImage from './assets/turbo-crown-hero.webp?url';
import './styles.css';
import './i18n.js';

const version=__APP_VERSION__;

document.querySelectorAll('[data-game-icon]').forEach((image)=>{image.src=gameIcon;});
document.querySelectorAll('[data-hero-image]').forEach((image)=>{image.src=heroImage;});
document.querySelectorAll('[data-version]').forEach((element)=>{element.textContent=`v${version}`;});
const favicon=document.createElement('link');
favicon.rel='icon';
favicon.href=gameIcon;
document.head.append(favicon);

const navToggle=document.querySelector('[data-nav-toggle]');
const nav=document.querySelector('[data-nav]');
if(navToggle&&nav){
  navToggle.addEventListener('click',()=>{
    const open=navToggle.getAttribute('aria-expanded')!=='true';
    navToggle.setAttribute('aria-expanded',String(open));
    nav.classList.toggle('is-open',open);
  });
}

const revealObserver=new IntersectionObserver((entries)=>{
  entries.forEach((entry)=>{
    if(!entry.isIntersecting)return;
    entry.target.classList.add('is-visible');
    revealObserver.unobserve(entry.target);
  });
},{threshold:0.14});

document.querySelectorAll('[data-reveal]').forEach((element)=>revealObserver.observe(element));
